module.exports = __webpack_public_path__ + "img/case-icon3.9b26e081.jpg";